<template>
<div class="container">
<b-row >
<b-container >
	<md-table v-model="bpo" md-card md-fixed-header >
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell class="text-left "><h6>{{item.name}}</h6></md-table-cell>
		<md-table-cell class="text-left "><h6>{{item.email}}</h6></md-table-cell>
		<md-table-cell class="text-left ">
			<h6><select v-model="item.nuevo_lider" v-on:click="f_cambia_bpo(item)">
                                <option value="">Seleccione...</option>
                                <option v-for="lider in lideres" :key="lider.nuevo_lider" :value="lider.id_lider">{{ lider.name }}</option>
			</select></h6>
		</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
</b-row>
</div>
</template>
<script>
import User from "@/services/User"
import Lider from "@/services/Lideres"

export default {
name:'LideresBPO',
data: () => ({
	factura: '',
	pais: '',
	users : [],
	bpo : [],
	lideres : [],
	listLiderUsuarios : [],
	fgl_grabar: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			nombre : "USUARIO",
			email : "E-MAIL",
			lider : "LIDER",
		}
	}else{
		return {
			nombre : "User",
			email : "e-mail",
			lider : "Lider",
		}
	}
}
},
mounted(){
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
		this.bpo = []
		this.lideres = []
		this.users.forEach((usuario) => {
			if	(usuario.id_rol == 4) {
				usuario.id_lider = usuario.id
				this.lideres.push(usuario)
			}
		})
	})
	.catch((err) => {
		console.log(err)
	})
	Lider.leaLiderUsuarios()
	.then((res) => {
		this.listLiderUsuarios= res.data.listLiderUsuarios
		this.users.forEach((usuario) => {
			if	(usuario.id_rol == 5) {
				const lider_usuario = this.listLiderUsuarios.find((lider) => lider.id_usuario==usuario.id)
				const flag =  lider_usuario == undefined
				if	(flag==false) {
					const lider = this.lideres.find((lider) => lider.id == lider_usuario.id_lider)
					const flag =  lider == undefined
					if	(flag==false) {
						usuario.id_lider=lider.id
						usuario.nuevo_lider=lider.id
					} else {
						usuario.id_lider=''
						usuario.nuevo_lider=''
					}
				} else {
					usuario.id_lider=''
					usuario.nuevo_lider=''
				}
				this.bpo.push(usuario)
			}
		})
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_cambia_bpo(usuario) {
		usuario.u_crea=this.$store.state.userId
		Lider.cambieLiderUsuario(usuario)
		.then((res) => {
			if	(res.status == 200) {
				this.$toast.success("Lider Asignado")
				usuario.id_lider = usuario.nuevo_lider
			} else {
				this.$toast.error("Lider no asignado ")
			}
		})
	},
	f_titulo() {
		return "REASIGNACION DE BPO A LIDERES"
	},
	f_nombre_usuario(id) {
		if	(id === undefined || id === null) {
			return "No Definido"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		if	(usuario == undefined) {
			return "SIN Informacion en BD "+id
		}
		return usuario.name
	},
}

}
</script>

<style>
table {
	table-layout:auto !important;
	margin-left: 1%;
	margin-right: 1%;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}

</style>
